import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {Button} from "react-bootstrap";
// eslint-disable-next-line no-restricted-imports
import {lighten, makeStyles} from "@material-ui/core/styles";
import {format} from "date-fns";
import AlertComponent from "../../../../../_metronic/_helpers/AlertComponent";
// eslint-disable-next-line no-restricted-imports
import {azAZ} from "@material-ui/core/locale";

import {
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar,
    TextField,
    Paper,
    CircularProgress,
    TableSortLabel,
    createMuiTheme,
    ThemeProvider,
    InputLabel,
    FormControl
} from "@material-ui/core";
// eslint-disable-next-line no-restricted-imports
import TablePagination from "@material-ui/core/TablePagination";
import {Badge} from "react-bootstrap";
import {DateTimePickerOutlined} from "../../../../components/DatePicker";
import {GMTDateConvert} from "../../../../../helpers";
import dayjs from "dayjs";


const theme = createMuiTheme(azAZ);

const headRows = [
    {
        id: "order",
        numeric: false,
        disablePadding: true,
        label: "Sıra",
    },
    {
        id: "ticketId",
        numeric: false,
        disablePadding: true,
        label: "Bilet nömrəsi",
    },
    {
        id: "ticketStatus",
        numeric: false,
        disablePadding: true,
        label: "Bilet statusu",
    },
    {
        id: "amount",
        numeric: false,
        disablePadding: true,
        label: "Məbləğ",
    },
    {
        id: "agentBalance",
        numeric: false,
        disablePadding: true,
        label: "Öncəki balans",
    },
    {
        id: "agentBalance",
        numeric: false,
        disablePadding: true,
        label: "Sonrakı balans",
    },
    {
        id: "typeName",
        numeric: false,
        disablePadding: true,
        label: "Tranzaksiya növü",
    },
    {
        id: "createdInAgency",
        numeric: false,
        disablePadding: true,
        label: "Yaradılma növü",
    },
    {
        id: "date",
        numeric: false,
        disablePadding: true,
        label: "Tarix",
    },
];

function EnhancedTableHead({onRequestSort, sortField, orderBy}) {
    return (
        <TableHead>
            <TableRow>
                {headRows.map((row, index) => (
                    <TableCell
                        sortDirection={sortField === row.id ? "asc" : false}
                        key={index}
                        align={row.numeric ? "right" : "left"}
                    >
                        <TableSortLabel
                            active={sortField === row.id}
                            direction={orderBy ? "desc" : "asc"}
                            onClick={() => {
                                onRequestSort(row.id);
                            }}
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: "0 0 auto",
    },
    dense: {
        margin: theme.spacing(2),
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const {numSelected, setTabs, setSkip} = props;

    const [value, setValue] = React.useState(0);

    function handleChange(event, newValue) {
        setValue(newValue);
        setTabs(newValue);
        setSkip(0);
    }

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                <Paper className="mb-4 mt-2">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="secondary"
                        centered
                    >
                        <Tab label="Bilet ödənişi"/>
                        <Tab label="Bilet satışı"/>
                        <Tab label="Ləğv"/>
                    </Tabs>
                </Paper>
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    progressRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
}));

const badges = {
    0: {
        label: "Bilet ödənişi",
        variant: "success",
    },
    1: {
        label: "Bilet satışı",
        variant: "danger",
    },
    2: {
        label: "Ləğv",
        variant: "warning",
    },
};

const ticketStatuses = {
    Win: {
        label: "Uduşlu",
        variant: "success",
    },
    Lost: {
        label: "Uduşsuz",
        variant: "danger",
    },
    Cancel: {
        label: "Bilet ləğvi",
        variant: "warning",
    },
    Pending: {
        label: "Açıq",
        variant: "info",
    },
};

export default function EnhancedTable({
                                          groups,
                                          tabs,
                                          setTabs,
                                          count,
                                          isLoading,
                                          isError,
                                          errorMsg,
                                          setText,
                                          setShowCreate,
                                          setShowRemoveGroups,
                                          deleteGroupsIds,
                                          setDeleteGroupsIds,
                                          sortField,
                                          setSortField,
                                          orderBy,
                                          setOrderBy,
                                          setSkip,
                                          setTake,
                                          take,
                                          skip,
                                          filterInputs,
                                          filterInputsUpdate,
                                          resetFilter,
                                          setFilterInputs
                                      }) {
    const classes = useStyles();

    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = groups.map((n) => n.id);
            setDeleteGroupsIds(newSelecteds);
            return;
        }
        setDeleteGroupsIds([]);
    }

    const isSelected = (name) => deleteGroupsIds.indexOf(name) !== -1;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleRequestSort = (field) => {
        const isOrder = field === sortField && !orderBy;

        setSortField(field);
        setOrderBy(isOrder);
        setTake(10);
        setRowsPerPage(10);
        setSkip(0);
        setPage(0);
    };

    function handleChangePage(event, newPage) {
        setPage(newPage);
        setSkip(take * newPage);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setTake(+event.target.value);
        setPage(0);
        setSkip(0);
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <div className="col-12 d-flex flex-wrap align-items-center py-4">
                    <div className="d-flex">
                        <div className="mr-2">
                            <InputLabel>Bilet nömrəsi</InputLabel>
                            <TextField
                                type="text"
                                name="ticketNumber"
                                value={filterInputs.ticketNumber}
                                onChange={filterInputsUpdate}
                                label="Bilet nömrəsi"
                                placeholder="Bilet nömrəsi"
                                variant="outlined"
                            />
                        </div>
                        <div className="mr-2">
                            <InputLabel>Başlanğıc tarixi</InputLabel>
                            <DateTimePickerOutlined
                                showTime
                                value={filterInputs.startDate ? dayjs(filterInputs.startDate) : ""}
                                onChange={value => setFilterInputs(prevState => ({
                                    ...prevState, startDate: value ? GMTDateConvert(value) : ""
                                }))}
                            />
                        </div>
                        <div>
                            <InputLabel>Bitmə tarixi</InputLabel>
                            <DateTimePickerOutlined
                                showTime
                                value={filterInputs.endDate ? dayjs(filterInputs.endDate) : ""}
                                onChange={value => setFilterInputs(prevState => ({
                                    ...prevState, endDate: value ? GMTDateConvert(value) : ""
                                }))}
                            />
                        </div>
                    </div>


                    <Button onClick={resetFilter} className="mx-2 my-2">
                        Sıfırla
                    </Button>
                </div>
                <EnhancedTableToolbar
                    numSelected={deleteGroupsIds.length}
                    setText={setText}
                    setShowCreate={setShowCreate}
                    setShowRemoveGroups={setShowRemoveGroups}
                    tabs={tabs}
                    setTabs={setTabs}
                    isLoading={isLoading}
                    setSkip={setSkip}
                />
                {isLoading && (
                    <div className={classes.progressRoot}>
                        <CircularProgress className={classes.progress}/>
                    </div>
                )}
                <div className={classes.tableWrapper}>
                    {groups.length ? (
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={deleteGroupsIds.length}
                                onSelectAllClick={handleSelectAllClick}
                                rowCount={groups.length}
                                onRequestSort={handleRequestSort}
                                sortField={sortField}
                                orderBy={orderBy}
                            />
                            <TableBody>
                                {groups.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    const timezoneOffset = new Date().getTimezoneOffset() / 60;
                                    const adjustedDate = new Date(row?.date);
                                    adjustedDate.setHours(
                                        adjustedDate.getHours() - timezoneOffset
                                    );
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={index}
                                            selected={isItemSelected}
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {skip + index + 1}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {`${row.ticketNumber.substring(0, 7)}*********`}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                <Badge
                                                    variant={
                                                        ticketStatuses[row.ticketStatus]?.variant ?? "info"
                                                    }
                                                >
                                                    {ticketStatuses[row.ticketStatus]?.label ??
                                                        row.ticketStatus}
                                                </Badge>
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.amount}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {tabs === 1
                                                    ? (row.agentBalance + row.amount).toFixed(2)
                                                    : (row.agentBalance - row.amount).toFixed(2)}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.agentBalance}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                <Badge variant={badges[row?.typeId]?.variant}>
                                                    {badges[row?.typeId]?.label}
                                                </Badge>
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.createdInAgency ? "agent" : "müştəri"}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.date &&
                                                    format(new Date(row.date), "dd.MM.yyyy HH:mm:ss")}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : !groups.length && !isLoading && !isError ? (
                        <AlertComponent variant="info" message="Məlumat tapılmadı."/>
                    ) : (
                        !isLoading &&
                        isError &&
                        !isLoading &&
                        isError && <AlertComponent variant="danger" message={errorMsg}/>
                    )}
                </div>
                {count > 10 && (
                    <ThemeProvider theme={theme}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                "aria-label": "Previous Page",
                            }}
                            nextIconButtonProps={{
                                "aria-label": "Next Page",
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </ThemeProvider>
                )}
            </Paper>
        </div>
    );
}
